export default __webpack_public_path__ + "static/media/hdb-construction-1.fd9e5c8d.svg";